import React, { useState, useEffect } from 'react';
import styles from './FirstScreen.module.css';
import heroImg from '../images/הילה תדמית מסך ראשי.png'; 
import Loader from '../components/loader/Loader';

const HeroSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 950);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    const img = new Image();
    img.src = heroImg;
    img.onload = () => setImageLoaded(true);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleWhatsAppClick = () => {
    const phoneNumber = '972558865332';
    const message = 'היי הילה הגעתי מהדף שלך, אשמח לשמוע ממך עוד על..';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  if (!imageLoaded) {
    return <Loader />;
  }

  return (
    <section className={styles.hero}>
      <div className={styles.decorElement3}></div>
      <div className={styles.decorElement4}></div>

      <div className={styles.container}>
        {isMobile ? (
          <>
            <div className={styles.subheadingWrapper}>
              <h2 className={styles.subheading}>
                לבעלי עסקים שמתעייפים מלרדוף אחרי לידים,
                ומרגישים שהתוכן לא מייצג את האמת על העסק שלהם.
              </h2>
            </div>

            <div className={styles.imageWrapper}>
              <img src={heroImg} alt="הילה - ניהול סושיאל" className={styles.image} />
            </div>

            <div className={styles.mobileContentWrapper}>
              <div className={styles.title}>
                להחזיר שליטה לשיווק שלך עם אסטרטגיה ותוכן שמחממים לידים, מייצרים אמון - ומביאים אלייך לקוחות שרוצים לעבוד <span className={styles.highlightedText}>דווקא איתך.</span>
              </div>

              <div className={styles.glassContainer}>
                <p className={styles.description}>
                  אסטרטגיה, ימי צילום, בנק תוכן וליווי שיווקי צמוד -
                  <br className={styles.lineBreak}/>
                  תשתית שמביאה לידים חמים ומכירות,
                  <br className={styles.lineBreak}/>
                  וקידום ממומן חכם שמעצים את החשיפה והתוצאות שלך.
                </p>
              </div>

              <button className={styles.ctaButton} onClick={handleWhatsAppClick}> אני מוכן להפוך למותג </button>
            </div>
          </>
        ) : (
          <>
            <div className={styles.textContent}>
              <div className={styles.subheadingWrapper}>
                <h2 className={styles.subheading}>
                  לבעלי עסקים שמתעייפים מלרדוף אחרי לידים,
                  ומרגישים שהתוכן לא מייצג את האמת על העסק שלהם.
                </h2>
              </div>

              <div className={styles.title}>
                להחזיר שליטה לשיווק שלך עם אסטרטגיה ותוכן שמחממים לידים, מייצרים אמון - ומביאים אלייך לקוחות שרוצים לעבוד <span className={styles.highlightedText}>דווקא איתך.</span>
              </div>

              <div className={styles.glassContainer}>
                <p className={styles.description}>
                  אסטרטגיה, ימי צילום, בנק תוכן וליווי שיווקי צמוד -
                  <br className={styles.lineBreak}/>
                  תשתית שמביאה לידים חמים ומכירות,
                  <br className={styles.lineBreak}/>
                  וקידום ממומן חכם שמעצים את החשיפה והתוצאות שלך.
                </p>
              </div>

              <button className={styles.ctaButton} onClick={handleWhatsAppClick}> אני מוכן להפוך למותג</button>
            </div>

            <div className={styles.imageWrapper}>
              <img src={heroImg} alt="הילה - ניהול סושיאל" className={styles.image} />
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default HeroSection;